import { render, staticRenderFns } from "./supplyweightpicture.vue?vue&type=template&id=0224e729&"
import script from "./supplyweightpicture.vue?vue&type=script&lang=ts&"
export * from "./supplyweightpicture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports